<script>
import { required } from 'vuelidate/lib/validators'
import { chars } from '@state/modules/chars'

export default {
	data() {
		return {
			states: [ 'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO' ],
			listTypes: [
				{ id: 1, name: 'Casamento'},
				{ id: 2, name: 'Chá casa nova'},
				{ id: 3, name: 'Chá de Panela'},
				{ id: 4, name: 'Chá Bar'},
				{ id: 5, name: 'Aniversário'},
				{ id: 6, name: 'Bodas'},
				{ id: 7, name: 'Open House'},
				{ id: 8, name: 'Noivado'}
			],
			listType: '',
			date: '',
			place: '',
			city: '',
			state: '',
		}
	},
	validations: {
		listType: { required },
		date: { required },
		place: { required },
		city: { required },
		state: { required },
		form: ['listType', 'date', 'place', 'city', 'state'],
	},
	methods: {
		...chars,
		validate() {
			this.$v.form.$touch()
			var isValid = !this.$v.form.$invalid
			this.$emit('on-validate', this.$data, isValid)
			return isValid
		},
	},
}
</script>

<template>
	<div>
	
		<div class="row">
			<div class="col-md-6">
				<div class="form-group mt-3 mt-sm-0">
					<label>Tipo de lista</label>
					<b-form-select class="mb-2" v-model.trim="listType" :class="{ 'is-invalid': $v.listType.$error }">
						<option v-for="(option, idx) in listTypes" :key="idx" :value="option.id">{{option.name}}</option>
					</b-form-select>
					<span v-if="$v.listType.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<div class="form-group mb-3">
					<label>Data do evento</label>
					<flat-pickr
						v-model.trim="date"
						class="form-control"
						name="date"
						:class="{ 'is-invalid': $v.date.$error }"
					></flat-pickr>
					<span v-if="$v.date.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</div>
			</div>
			<div class="col-md-6">
				<b-form-group label="Local do Evento">
					<b-form-input
						v-model.trim="place"
						:class="{ 'is-invalid': $v.place.$error }"
						type="text"
						placeholder="Informe o local do evento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.place.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Cidade do Evento">
					<b-form-input
						v-model.trim="city"
						:class="{ 'is-invalid': $v.city.$error }"
						type="text"
						placeholder="Informe a cidade do evento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent						
					></b-form-input>
					<span v-if="$v.city.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<div class="form-group mt-3 mt-sm-0">
					<label for="default">Estado</label>
					<b-form-select v-model="selected" class="mb-2" :options="states" v-model.trim="state" :class="{ 'is-invalid': $v.state.$error }"></b-form-select>
				</div>
			</div>
		</div>
		
	</div>
</template>
